import React from 'react';

import type { PlotUtilities } from './renderers/types';
import type { MarkAnnotation } from './types';
import { markPrefix } from './utilities/utils';

type MarksContainerProps = {
    plotUtilities?: PlotUtilities;
    marks?: MarkAnnotation[];
    selectedMark?: MarkAnnotation['legendLabel'];
};

const defocusedMarkOpacity = 0.3;

export const MarksContainer: React.FC<MarksContainerProps> = ({ plotUtilities, marks, selectedMark }) => {
    if (!plotUtilities || !marks) {
        return null;
    }

    return (
        <>
            {marks.map(mark => {
                // Compute mark
                const markScale = mark.scale || 'y';
                // Only 1 xAxis is allowed so if the scale isn't that we know it's the Y axis
                const isMarkScaleY = markScale !== 'x';
                const markPosByScale = plotUtilities.valToPos(mark.value, markScale);
                const boundary = plotUtilities.dimensions.over[isMarkScaleY ? 'height' : 'width'];

                if (markPosByScale > boundary) {
                    return null;
                }

                let opacity = 1;
                if (selectedMark) {
                    if (`${markPrefix}${mark.legendLabel}` !== selectedMark) {
                        opacity = defocusedMarkOpacity;
                    }
                }

                const markStyleObj: React.CSSProperties = {
                    position: 'absolute',
                    ...(isMarkScaleY
                        ? {
                              top: markPosByScale,
                              width: '100%',
                              borderTopWidth: mark.width || 1,
                              borderTopColor: mark.color || '#666',
                              borderTopStyle: mark.style || 'solid',
                              opacity,
                          }
                        : {
                              left: markPosByScale,
                              height: '100%',
                              borderLeftWidth: mark.width || 1,
                              borderLeftColor: mark.color || '#666',
                              borderLeftStyle: mark.style || 'solid',
                              opacity,
                          }),
                };

                return (
                    <div key={mark.value} data-test={`viz-mark-value-${mark.value}`}>
                        <div style={markStyleObj} />
                    </div>
                );
            })}
        </>
    );
};
